import "./../App.css";
import "./../AppMobile.css";

import React from "react";
import { hideProcess, setLocaleApp, showProcess } from "../utils/util";

import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import authenticateService from "../services/authenticateService";
import accountService from "../services/accountService";
import { TabPanel, TabView } from "primereact/tabview";
import Login from "./login";
import Register from "./register";

export default class TabLogin extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        
    }

    render() {
        return (
            <TabView className="app-tabview-login" activeIndex={this.props.activeIndex}>
                <TabPanel header="Login">
                    <Login />
                </TabPanel>
                <TabPanel header="Criar conta">
                    <Register />
                </TabPanel>
            </TabView>
        );
    }
}
